import { Add as AddIcon } from "@mui/icons-material"
import { Button } from "@mui/material"
import MUIDataTable from "mui-datatables"
import { LoadingOverlay } from "./LoadingOverlay"
import { useData } from "../hooks/context"

interface ListComponentProps {
  onSuccess?: () => void
  format?: (data: any) => any
  defaultAddData?: any
  data?: any[]
}

export const ListComponent = ({ onSuccess, format, defaultAddData, data }: ListComponentProps) => {
  const { list, loading, columns, options, openAdd, Service } = useData()
  return (
    <LoadingOverlay loading={loading} text={Service.LOADING_MESSAGE}>
      <div className="m-3">
        <Button
          variant="contained"
          color="primary"
          onClick={(event) => {
            event.stopPropagation()
            openAdd(defaultAddData, format, onSuccess)
          }}
        >
          <AddIcon />
        </Button>
      </div>
      {!loading && (
        <MUIDataTable
          responsive="simple"
          title={Service.TITLE}
          data={data || list}
          columns={columns}
          options={options}
        />
      )}
    </LoadingOverlay>
  )
}
